import { deepMerge } from '../../utils/deepMerge';
export const genericMap2LegacyTheme = (tokens, legacyThemeProperty, map) => {
  const legacyThemeObject = Object.entries(legacyThemeProperty).reduce((legacyThemeObject, _ref) => {
    let [legacyThemeKey] = _ref;
    const cssVariable = legacyThemeKey !== '' ? map[legacyThemeKey] : undefined;
    const tokenValue = cssVariable && tokens[':root'] ? tokens[':root'][cssVariable] : undefined;
    return !cssVariable && !tokenValue ? legacyThemeObject : {
      ...legacyThemeObject,
      [legacyThemeKey]: tokenValue
    };
  }, {});
  return deepMerge({}, legacyThemeProperty, legacyThemeObject);
};